// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.crypto-wallet-card[data-v-39a88f1a] {\n    width: 300px;\n    min-width: 300px;\n}\n@media screen and (width <= 440px) {\n.crypto-wallet-card[data-v-39a88f1a] {\n        width: 100%;\n        min-width: 100%;\n}\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
